import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ImovelStorage } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImovelStorageService extends BaseResourceService<ImovelStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`imovel-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, imovel: number, descricao?: string, foto?: boolean): Observable<ImovelStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }
    if (foto) {
      formData.append('foto', 'S');
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<ImovelStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${imovel}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
  
  public definirPrincipal(tombamento: number, id: number): Observable<any> {
    return this.http.post<any>(`${this.login.cidade.id}/${this.api}/definir-principal/${tombamento}/${id}`, undefined, this.httpOptions())
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
